<div class="min-h-screen flex flex-col items-center justify-center bg-gray-50">
  <p-progressSpinner
    class="w-16 h-16"
    strokeWidth="4"
  ></p-progressSpinner>
  <p class="mt-4 text-gray-600 text-lg font-medium">
    Signing you in. Please wait...
  </p>
</div>
